import { useReducer } from 'react'

const reducer = () => ({})

const useForceUpdate = () => {
  const [, setTrigger] = useReducer(reducer, {})

  return setTrigger
}

export default useForceUpdate
